import { useState, useEffect } from "react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowH = window.innerHeight;
      const docH = document.documentElement.scrollHeight;

      setVisible(scrollY > windowH * 0.6);
      setNearFooter(scrollY + windowH > docH - 160);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`fixed right-6 z-40 transition-all duration-500 ease-out ${
        nearFooter ? "bottom-24" : "bottom-8"
      } ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        onClick={handleClick}
        aria-label="ページトップへ戻る"
        className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 border border-[#0ABAB5]/30 text-[#0ABAB5] hover:bg-[#0ABAB5] hover:text-white hover:border-[#0ABAB5] transition-all duration-200 cursor-pointer"
        style={{ backdropFilter: "blur(8px)" }}
      >
        <i className="ri-arrow-up-line text-xl" />
      </button>
    </div>
  );
}
